export enum Mask {
  DATE = '99/99/9999',
  PHONE = '(999) 999-9999',
}
